import { Injectable, Output, EventEmitter, Directive } from '@angular/core'
import { UserService } from '../services/user.service';
import { ServerService } from '../services/server.service';
import { LlRolesService } from './ll-roles.service';
//import { LlModelsService } from './ll-models.service';
//import { LlCompaniesService } from './ll-companies.service';
import { LlPermissionsService } from './ll-permissions.service';


@Directive()
@Injectable({
  providedIn: 'root'
})

export class LlInfoBuildService {
  
  constructor(public ServerService: ServerService,
    private UserService: UserService,
    private LlRolesService: LlRolesService,
    private LlPermissionsService: LlPermissionsService,
  ) { }  

  vars = {
    ac: "",
    APPLICATIONVERSION: "",
    CONTACTID: 0,
    COMPANYID: 0,
    COMPANYID_ACTIVE:0,
    STUDYID_SYS: 0,
    CONTACTROLEID: 0,
    SYSTEMROLEID: 0,
    STUDYVISITID: 0,
    STUDYVISITFORMID: 0,
    STUDYQUESTIONID:0,
    QUESTION_OBJ: [],
  }
    
  bundle_local = {

    //studyVisits: [],
    //studyForms: [],
    //studyVisitForms: [],
    //studyQuestions: [],
    //questionChoices: [],

    //inBundle: [],    
    benchmarkValues: [],

    vars: this.vars,
  }

  setActiveSTUDYVISITID(ID) {
    this.bundle_local.vars.STUDYVISITID = ID;
  }
  setActiveSTUDYVISITFORMID(ID) {
    this.bundle_local.vars.STUDYVISITFORMID = ID;
  }
  setActiveSTUDYQUESTIONID(ID) {
    this.bundle_local.vars.STUDYQUESTIONID = ID;
  }

  NG_LL_infoReq_build_visits_get(callback01?: Function) {

    var user = this.UserService.getActiveUser();

    this.bundle_local.vars.ac = "NG_LL_infoReq_build_visits_get"
    this.bundle_local.vars.APPLICATIONVERSION = user.APPLICATIONVERSION;
    this.bundle_local.vars.CONTACTID = user.CONTACTID;
    this.bundle_local.vars.COMPANYID = user.COMPANYID;
    this.bundle_local.vars.CONTACTROLEID = this.LlRolesService.getActiveContactRoleId();
    this.bundle_local.vars.SYSTEMROLEID = this.LlRolesService.getActiveSystemRoleId();  

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

     

      if (arr.length > 0) {
        bundle_local.vars.STUDYVISITID = arr[0].STUDYVISITID;
      }

      callback01(arr);    

    }

  }

  NG_LL_infoReq_build_visit_forms_get(callback01?: Function) {
    this.bundle_local.vars.ac = "NG_LL_infoReq_build_visit_forms_get";

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      if (arr.length > 0) {
        bundle_local.vars.STUDYQUESTIONID = arr[0].STUDYQUESTIONID;
      }

      callback01(arr);

    }

  }

  NG_LL_infoReq_build_form_questions_get(callback01?: Function) {
    this.bundle_local.vars.ac = "NG_LL_infoReq_build_form_questions_get";

   
    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      if (arr.length > 0) {
        bundle_local.vars.STUDYVISITFORMID = arr[0].STUDYVISITFORMID;
      }

      callback01(arr);

    }

  }

  NG_LL_infoReq_build_form_question_edit(question_obj) {
    this.bundle_local.vars.ac = "NG_LL_infoReq_build_form_question_edit";
    this.bundle_local.vars.QUESTION_OBJ = question_obj;

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

    }

  }

}
